import formStyles from "@components/Form/FormFields/FormFields.module.scss";
import { SelectAutocompleteProps } from "@components/SelectAutocomplete/interfaces";
import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import useOnClickOutside from "../../utils/hooks/useOnClickOutside";
import styles from "./SelectAutocomplete.module.scss";

const SelectAutocomplete = (props: SelectAutocompleteProps) => {
  const {
    value,
    register,
    trigger,
    errors,
    name,
    validation,
    placeholder,
    options,
    getOptions,
    setValue,
    clearErrors,
  } = props;

  const hasError = errors && errors[name];

  const [isFocused, setIsFocused] = useState(false);
  const [isShowOptions, setShowOptions] = useState(false);

  useEffect(() => {
    setIsFocused(!!value);
  }, [value]);

  const handleOptionSelect = (option) => {
    setValue(name, option);
    getOptions(option);
    clearErrors(name);
    setIsFocused(!!value);
    setShowOptions(false);
  };

  const handleOnBlur = () => {
    setIsFocused(!!value);
    setShowOptions(false);
    if (value?.trim()) trigger(name);
  };

  const handleOnFocus = () => {
    setIsFocused(true);
  };

  const handleInputOnChange = (e) => {
    setValue(name, e.target.value);
    getOptions(e.target.value.trim());
    setShowOptions(true);
  };

  const fieldRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(fieldRef, () => handleOnBlur());

  return (
    <div
      className={clsx(
        "form",
        "form-row",
        formStyles["form-row"],
        "field-row",
        styles["country-section"],
        isFocused && formStyles["focused"],
        hasError && formStyles["error"]
      )}
    >
      <div className={formStyles["form-label"]}>
        <div className={formStyles["label"]}>
          <label htmlFor={name}>{placeholder}</label>
        </div>
      </div>
      <div className={formStyles["form-field"]}>
        <div className={formStyles["field"]} ref={fieldRef}>
          <>
            <input
              id={name}
              name={name}
              type="text"
              value={value}
              autoComplete="off"
              onFocus={handleOnFocus}
              {...register(name, {
                onChange: handleInputOnChange,
                onBlur: handleOnBlur,
                ...validation,
              })}
              aria-required={!!validation?.required}
              aria-describedby={hasError ? `${name}-error` : undefined}
            />
            {isShowOptions && options?.length > 0 && (
              <ul className={styles["countries-wrapper"]}>
                {options?.map((option, index) => (
                  <li
                    key={`${option}${index}`}
                    className={styles["countries-item"]}
                  >
                    <button
                      type="button"
                      onClick={() => handleOptionSelect(option)}
                    >
                      {option}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </>
        </div>

        {hasError && (
          <div className={clsx(formStyles["form-row"], formStyles.error)}>
            <div className={formStyles["form-field"]}>
              <div
                className={clsx(
                  formStyles["field"],
                  "field",
                  "message-wrapper",
                  formStyles["message-wrapper"],
                  "inline-message",
                  "field_error_msg"
                )}
              >
                <p
                  className={clsx(
                    "message",
                    "active",
                    formStyles["message"],
                    formStyles["active"]
                  )}
                  id={`${name}-error`}
                >
                  {errors?.[name]?.message as string}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectAutocomplete;
